module.exports = __webpack_public_path__ + "img/circle.304f352c.svg";